export default "__VITE_ASSET__dc9ab498__"